export default __webpack_public_path__ + "static/media/VReg.370b8ccc.svg";